import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { LanguageCode, mergeObjects, translations as core } from "@vana/core";
import { translations as home } from "@vana/home";
import { translations as shell } from "../translations/translations";
import { locale } from "./build";

const translations = mergeObjects(core, home, shell);

i18next
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: locale.languageCode,
    fallbackLng: LanguageCode.ES_GT,
    interpolation: { escapeValue: false },
  })
  .catch(() => {
    console.log("error loading translations");
  });

export const i18n = i18next;
